var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow45Deg = function SvgArrow45Deg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    fill: "none",
    viewBox: "0 0 26 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.476 2.29c0-.841-.66-1.523-1.476-1.523H10.716c-.815 0-1.476.682-1.476 1.523 0 .842.66 1.524 1.476 1.524h11.808v12.189c0 .841.66 1.523 1.476 1.523.815 0 1.476-.682 1.476-1.523zM3.044 26.077l22-22.71-2.088-2.154-22 22.71z"
  })));
};
export default SvgArrow45Deg;